import React, { useMemo } from "react";
import { ApolloError } from "@apollo/client";
import { FormSelect as Select } from "@jsq/ds/forms";
import { useGetCountriesQuery } from "../../../graphql/supergraphHooks";
import { clientContext } from "../../../utils/graphql_utils";
import { capitalizeEachWord } from "../../../utils/text_utils";
import {
  CountrySelectProps,
  type GetCountryValue,
} from "../../common/SharedAddressInput/types";

export const defaultGetValue: GetCountryValue = (country) => country.code;

export const ComplianceCountrySelect: React.FunctionComponent<CountrySelectProps> = ({
  isFull = true,
  placeholder = "Select a country",
  handleChange = undefined,
  getValue = defaultGetValue,
  label = undefined,
}) => {
  const { data, error } = useGetCountriesQuery({
    context: clientContext(),
    fetchPolicy: "no-cache",
  }) as unknown as {
    data: { complianceCountries: Array<{ alpha2code: string; name: string; id: string }> };
    error: ApolloError | undefined;
  };
  const countryList = useMemo(() => {
    return (
      data?.complianceCountries
        ?.filter((country) => !!country?.alpha2code)
        ?.map((country) => {
          return { code: country.alpha2code || "", name: country.name, id: country.id };
        })
        ?.sort((c1, c2) => (c1.name < c2.name ? -1 : 1)) || []
    );
  }, [data]);

  if (error) {
    return null;
  }
  return (
    <Select
      name="country"
      full={isFull}
      placeholder={placeholder}
      handleChange={handleChange}
      data-cy="country-country"
      data-testid="country-country"
      label={label}
    >
      <Select.Section>
        {countryList.map((country) => (
          <Select.Option key={country.id} value={getValue(country)}>
            {country.name === "U.S. Virgin Islands" // capitalizeEachWord turns U.S. Virgin Islands to U.s. Virgin Islands
              ? country.name
              : capitalizeEachWord(country.name)}
          </Select.Option>
        ))}
      </Select.Section>
    </Select>
  );
};
